module.exports = __webpack_public_path__ + "static/media/webiste-image-3.f6beef50.png";